import { Badge, ButtonGroup, Tag, Td, Tr, useDisclosure } from "@chakra-ui/react"
import { Alert, IconButton, Show, Table } from "components"
import { Enums } from "config"
import { Mask } from "config"
import Approve from "./approve"
import { useState } from "react"
import { useOrder } from "hooks"
import { Link } from "react-router-dom"

export default function Transactions({ data, ...props }){
    
    const order = useOrder(data.id)
    const [ approve, setApprove ] = useState(false) 

    // Se não houver pagamentos, mostra uma mensagem
    if(!order.data?.transactions?.length) return <Alert title="Não foram registrados pagamentos pelo sistema neste pedido." />

    return(
    <>
    <Table columns={[{ children: 'Método' }, { children: 'Pagador' }, { children: 'Status' }, { children: 'Valor', isNumeric: true }, { children: '', isNumeric: true }]}>
        { order.data?.transactions.map(item => (
            <Tr key={item.id}>
                <Td><Badge>{item.method_label}</Badge></Td>
                <Td>{ item.method === 7
                    ? item.consultant?.id
                        ? <Link to={`/consultants/${item.consultant.id}`}>{item.consultant.customer?.name}</Link>
                        : '—'
                    : '—'
                }</Td>
                <Td><Tag size="sm" colorScheme={Enums.TransactionStatus.data(item.status).colorScheme} children={Enums.TransactionStatus.data(item.status).label} /></Td>
                <Td isNumeric>R$ {Mask.price(item.amount)}</Td>
                <Td isNumeric>
                    <ButtonGroup size="xs">
                        <Show visible={item.status === Enums.TransactionStatus.ANALYZING && order.data?.is_matriz && item.method !== 7}><IconButton icon="check" label="Aprovar pagamento" colorScheme="teal" onClick={() => setApprove(item)} /></Show>
                        <Show visible={!!item.receipt}><IconButton icon="attachment" label="Visualizar comprovante" onClick={() => window.open(item.receipt.download_url)} /></Show>
                    </ButtonGroup>
                </Td>
            </Tr>
        )) }
    </Table>

    {/* Screens */}
    <Approve isOpen={!!approve} onClose={() => setApprove(false)} data={approve} onSuccess={order.refetch} />
    </>
    )
}